module.exports = __webpack_public_path__ + "static/media/user-times.c1d09239.svg";